import { createActions } from 'redux-actions';


const actionCreators = createActions({
    USERS: {
        DATA: {
            SET: data => data,
            RESET: undefined,
        },
        EMAIL_LOGS: {
            FETCH_REQUEST: undefined,
            FETCH_SUCCESS: emailLogs => ({ emailLogs }),
            FETCH_FAILURE: error => ({ error }),
            RESET: undefined,
        },
        SSO_DATA: {
            FETCH_REQUEST: undefined,
            FETCH_SUCCESS: ssoData => ({ ssoData }),
            FETCH_FAILURE: error => ({ error }),
        },
    },
});

export default actionCreators.users;
